export const formatRole = (role) => {
    return role
        ?.toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
};